import React, {createContext, useMemo, useState, useCallback} from 'react';

export const VaultContext = createContext(null);

export function VaultProvider({children}){
  const [status, setStatus] = useState({});

  const setMessage = useCallback((k,v)=>{
    setStatus(s => ({...s,[k]:v}));
  },[]);

  const value = useMemo(()=>({status, setMessage}),[status,setMessage]);

  return (
    <VaultContext.Provider value={value}>{children}</VaultContext.Provider>
  );
}
